import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import KnownSourceLayer from '../components/KnownSourceLayer';

const KnownSourcePage = () => {
    return (
        <MasterLayout>
            <KnownSourceLayer />
        </MasterLayout>
    );
};

export default KnownSourcePage;
